import { fetchNfcCard } from 'lib/models/nfcCards';
import { useCallback, useEffect, useState } from 'react';

/** One card by its id, as the header of its screens shows it. */
function useNfcCard(cardId: string) {
	const [loading, setLoading] = useState<boolean>(false);

	const [card, setCard] = useState<NfcCard | null>(null);

	const refetch = useCallback(async () => {
		setLoading(true);
		setCard(await fetchNfcCard(cardId));
		setLoading(false);
	}, [cardId]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, card, refetch };
}

export default useNfcCard;
